.root {
  display: inline-flex;
}

.badge {
  cursor: pointer;
}

.tooltip {
  max-width: 250px;
}
